import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Edit Payment Method",
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Save",
        color: "primary",
        task: _ctx.task,
        onClick: _ctx.save
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createVNode(_component_q_input, {
          label: "Label",
          modelValue: _ctx.label,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.label) = $event)),
          outlined: "",
          hint: "e.g. Personal, Business",
          clearable: ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 512))
}